import { LcaDiagramColumns } from 'src/Lca/LCADiagram/Diagram/index.types';

type ShouldShowGlnCalculatorParams = {
  distanceBreakdownIndex: number;
  shouldUseSplitAmount: boolean;
  stage: string | null | undefined;
  unit: string | null | undefined;
};

const shouldShowGlnCalculator = ({
  distanceBreakdownIndex,
  shouldUseSplitAmount,
  stage,
  unit,
}: ShouldShowGlnCalculatorParams): boolean => {
  const isEligibleForDistanceCalculation =
    stage === LcaDiagramColumns.transportOfRawMaterials ||
    Boolean(unit?.includes('km'));

  if (!isEligibleForDistanceCalculation) {
    return false;
  }

  return !shouldUseSplitAmount || distanceBreakdownIndex >= 0;
};

export default shouldShowGlnCalculator;
